// @flow
import React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import { Wrap } from "componentsStyled/Layout/Wrap"
import Button from "components/Button"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"

type Props = {|
  close: Function,
|}

const Success = ({ close }: Props) => (
  <React.Fragment>
    <ModalContent>
      <Wrap>
        <Text>
          We’ve just sent password resetting instructions to your email.
        </Text>
      </Wrap>
    </ModalContent>
    <ModalControls>
      <Button fullwidth onClick={close}>
        Okay
      </Button>
    </ModalControls>
  </React.Fragment>
)

export default Success



// WEBPACK FOOTER //
// ./src/modals/ForgotPassword/Success/index.js